import React from "react";

export const AddButtonIcon = ({ fill, ...props }) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="39"
            height="25"
            viewBox="0 0 39 25"
        >
            <rect width="39" height="25" rx="12.5" opacity="0.544" />
            <g transform="translate(90 -49.952)">
                <path
                    d="m-63.843 61.255h-5.7832v-5.6082c0-0.6645-0.55314-1.2009-1.2384-1.2009s-1.2384 0.5364-1.2384 1.2009v5.6082h-5.7832c-0.68524 0-1.2384 0.5364-1.2384 1.2009s0.55314 1.2009 1.2384 1.2009h5.7832v5.6082c0 0.6645 0.55314 1.2009 1.2384 1.2009s1.2384-0.5364 1.2384-1.2009v-5.6082h5.7832c0.68524 0 1.2384-0.5364 1.2384-1.2009s-0.55314-1.2009-1.2384-1.2009z"
                    fill="#fff"
                    strokeWidth=".4065"
                />
            </g>
        </svg>
    );
};
